module.exports = __webpack_public_path__ + "static/contact-us.16fe1a92.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/contact-us.png
// module id = 1005
// module chunks = 2